export const formAccidentNaming = {
  ADD_BASIC_INFO_ACCIDENT_FORM: 'add-basic-info-accident-form',
  NEW_ACCIDENT_FORM: 'new-accident-form',
  SELECTED_ACCIDENTS_FILES: 'selected-accidents-files',
  IMAGE_CANVAS: 'image-canvas',
  SVG_CANVAS: 'svg-canvas',
  ARRAY_CANVAS: 'array-canvas',
  EDIT_ACCIDENT_FORM: 'edit-accident-form',
  EDIT_BASIC_INFO_ACCIDENT_FORM: 'edit-basic-info-accident-form',
  ACCIDENT_NAVIGATION_CONTEXT: 'accident-navigation-context',
};

export const directoryNaming = {
  CANVAS: 'canvas-accident',
};
